import { Scenarios } from '@jfs/network'

const addNewCustomerDetails = {
  default: [
    {
      url: /user/,
      method: 'POST',
      response: {
        status: 'SUCCESS',
        data: {
          status: 'SUCCESS',
          remittanceUserId: '1821038411286220083',
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /user/,
      method: 'POST',
      responseCode: 55101,
      response: { status: 'FAILURE', error: { code: '33607', message: 'User does not exist.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { addNewCustomerDetails }
